import { get, post, patch, Delete } from '@/utils/https'

export type ResourceCommentType = 'mission' | 'activity_report'

export interface FetchResourceCommentsParams {
  resourceType: ResourceCommentType
  resourceId: string
  limit?: number
  offset?: number
}

export const fetchResourceComments = (params: FetchResourceCommentsParams) =>
  get('/api/app/v1/resource-comments', {
    resource_type: params.resourceType,
    resource_id: params.resourceId,
    limit: params.limit ?? 20,
    offset: params.offset ?? 0,
  })

export const createResourceComment = (payload: {
  resource_type: ResourceCommentType
  resource_id: string
  body: string
}) => post('/api/app/v1/resource-comments', payload)

export const updateResourceComment = (commentId: string, body: string) =>
  patch(`/api/app/v1/resource-comments/${commentId}`, { body })

export const deleteResourceComment = (commentId: string) =>
  Delete(`/api/app/v1/resource-comments/${commentId}`)

export const fetchCommentUnreadSummary = (teamId: string) =>
  get('/api/app/v1/resource-comments/unread-summary', { team_id: teamId })
